module.exports = __webpack_public_path__ + "img/bg.62666969.png";